export const WrappedDateRangePickerDefProps = {
  addClasses: "WrappedDateRangePicker_shiftedRightForUiKit",
  propValue: '',
  onChange: () => {}
};